import { useState } from "react";
import { Input } from "./ui/input";
import { Calendar } from "lucide-react";

const PRESETS = ["Today", "Yesterday", "This Week", "This Month", "All", "Custom"];

function iso(d) { return d.toISOString().slice(0, 10); }

export function resolveRange(preset, customFrom, customTo) {
  const now = new Date();
  const t = iso(now);
  if (preset === "Today") return { from: t, to: t };
  if (preset === "Yesterday") { const y = new Date(now); y.setDate(y.getDate() - 1); return { from: iso(y), to: iso(y) }; }
  if (preset === "This Week") { const s = new Date(now); const day = (s.getDay() + 6) % 7; s.setDate(s.getDate() - day); return { from: iso(s), to: t }; }
  if (preset === "This Month") { const s = new Date(now.getFullYear(), now.getMonth(), 1); return { from: iso(s), to: t }; }
  if (preset === "Custom") return { from: customFrom || "", to: customTo || "" };
  return { from: "", to: "" };
}

export default function DateFilter({ value, onChange, customFrom, customTo, setCustomFrom, setCustomTo }) {
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="date-filter">
      <span className="text-sm font-semibold text-brand-slate flex items-center gap-1.5"><Calendar className="w-4 h-4" /> Date</span>
      {PRESETS.map((p) => (
        <button key={p} data-testid={`date-preset-${p.toLowerCase().replace(/\s/g, "-")}`} onClick={() => onChange(p)}
          className={`text-xs font-semibold px-3 py-1.5 rounded-full border transition-colors ${value === p ? "bg-brand-teal text-white border-brand-teal" : "border-border text-brand-slate hover:bg-slate-50"}`}>
          {p}
        </button>
      ))}
      {value === "Custom" && (
        <div className="flex items-center gap-2">
          <Input data-testid="date-custom-from" type="date" value={customFrom} onChange={(e) => setCustomFrom(e.target.value)} className="h-8 w-auto" />
          <span className="text-brand-slate">→</span>
          <Input data-testid="date-custom-to" type="date" value={customTo} onChange={(e) => setCustomTo(e.target.value)} className="h-8 w-auto" />
        </div>
      )}
    </div>
  );
}
